<template>
  <vue-scroll :ops="ops" ref="vs"  @handle-scroll="handleScroll">
    <div class="aboutCon">
      <first-Component  class="header" :class="{active:!isShowNav}"  style="position: absolute;top:0;z-index: 999;background-color: white;" :num=2 ></first-Component>

      <first-Component class="animated bounceInDown" style="position: fixed;
    z-index: 999999;
    background-color: white;animation-duration:3s;" :num=2 v-if="!isShowNav"></first-Component>

        <div class="banner animated zoomIn" id="d1">
            <div class="text animated fadeInLeft">
              <span>{{$t('home[1]')}}</span>
            </div>
            <img    style="width:100%;height:100%;cursor: pointer;display: block"  src="../assets/aboutBanner.png">
            <div class="threeBtn">
              <span :style="select2==0?oneStyle:''"  @click="showCon(0)">{{$t('aboutList[0]')}}</span>
              <span :style="select2==1?oneStyle:''"  @click="showCon(1)">{{$t('aboutList[1]')}}</span>
              <span :style="select2==2?oneStyle:''"  @click="showCon(2)">{{$t('aboutList[2]')}}</span>
            </div>
      </div>
      <div class="company" v-if="select2===0">
        <div class="mainOne wow fadeInUp">
          <div class="leftTitle">
<!--            <span>Welcome To</span>-->
<!--            <span class="b">BY </span>-->
<!--            <span class="c">Motor</span>-->
<!--            <span>World!</span>-->
            <span>{{$t('aboutT')}}</span>
          </div>
          <p>
            {{$t('about')}}
<!--            BY MOTOR is a world OEM and Aftermarket provider giving the foremost complete series of innovative driver visibility merchandise underneath a trusty complete providing artistic solutions for industrial and recreational vehicle markets. we tend to are a team of pros dedicated to assembling profitable, enduring growth among all our customers with an unrelenting drive to exceed customer’s expectations.-->
          </p>
          <img src="../assets/open.png" @click="show">
        </div>
        <div class="mainTwo wow fadeInUp">
          <div class="allText animated fadeInDown" :style="aStyle">
            <img src="../assets/ab.png" alt="">
            <p>
              {{$t('prond')}}
<!--              BY MOTOR is proud that our product is popular than the other manufacturer. As a “Leading in Industry” global manufacturer, BY MOTOR has continuously been a brand that provides professional auto parts product.-->
<!--              Designed and engineered with Original Equipment rigor and quality, our products serve vehicle makers, technicians and drivers all over. From conception to production and delivery, BY MOTOR provides superior visibility solutions – include all major kinds of motors making tomorrow safer for everybody on the road.-->
            </p>
          </div>
          <img class="blut" src="../assets/blue-1977898.png" alt="">
        </div>
      </div>
      <div class="mission animated zoomIn" v-else-if="select2===1">
        <img class="bg" src="../assets/man-3230661.png" alt="">
        <div class="title ">
          <p>{{$t('aboutList[1]')}}</p>
          <div class="three">
            <span style="left: 0"></span>
            <img src="../assets/d.png" alt="">
            <span style="right: 0;"></span>
          </div>

        </div>
        <div class="leftTitle">
<!--          <span class="b">BY </span>-->
          <span class="c" style="text-transform: uppercase">{{$t('Mission.TITLE')}}</span>
        </div>
        <div class="item wow fadeInUp" v-for="(item,index) in $t('Mission').content" :key="index">
       <p>{{item.title}}</p>
          <p>{{item.con}}</p>
        </div>
        <img style="width:100%;" src="../assets/bg-about-history.png" alt="">
      </div>
      <div class="company  social animated fadeInLeft " v-else>
        <div class="title wow fadeInUp">
          <p>{{$t('aboutList[2]')}}</p>
          <div class="three">
            <span style="left: 0"></span>
            <img src="../assets/d.png" alt="">
            <span style="right: 0;"></span>
          </div>
        </div>
        <div class="item wow fadeInUp">
          <p>{{$t('Social').TITLE1}}</p>
          <p>{{$t('Social').content1}}</p>
        </div>
        <div class="item itemTwo wow fadeInUp">
          <p>{{$t('Social').TITLE2}}</p>
          <p>{{$t('Social').content2}}</p>
          <a v-for="item in $t('Social').arr1">{{item}}</a>
          <p>{{$t('Social').content3}}</p>
          <a v-for="item in $t('Social').arr2">{{item}}</a>
          <img src="../assets/adventure-1807524.png" alt="">
        </div>
        <div class="item wow fadeInUp">
          <p>{{$t('Social').TITLE3}}</p>
          <p>{{$t('Social').content4}}
          </p>
        </div>
        <img style="width:100%;z-index: -1;" src="../assets/bg-about-history.png" alt="">
      </div>
      <foot-Component class="wow fadeInUp" @gotoTop="gotoTop"></foot-Component>

    </div>
  </vue-scroll>
</template>

<script>
  import firstComponent from './first'
  import footComponent from './foot'
  import  {WOW} from 'wowjs'
    export default {
        name: "about",
      data(){
          return{
            bgStyle:{backgroundColor:'#0C3665',color:'white'},
            isShowNav:true,
            content:[
              {title:"Leadership",con:"Show the tendency of taking on a visible role within a work group or team. Express the will to lead others and have the capacity to motivate individuals and teams with the purpose of achieving common goals, by delegating tasks and responsibilities and giving autonomy to the team. This implies both wanting to assume responsibility for the team and the degree of effectiveness in the creation of dependencies."},
              {title:"Communication",con:"The capacity to express clearly and understandably one’s own opinions and ideas. The ability to convey one’s own viewpoints precisely and intelligibly."},
              {title:"Resolution and Decision Making",con:"Identify problems and recognize relevant information. Be capable of diagnosing the possible causes of such problems and provide appropriate solutions at the right time. Decide among visible alternatives."},
              {title:"Creativity / Innovation",con:"Seeking imaginative solutions to problems related with work and being able to find innovative alternatives others than those normally used for resolution. Includes de capacity to bring new ideas that can turn into improvements or introduce changes geared at solving problems."},
              {title:"Teamwork",con:"Actively contribute to the achievement of a common goal. Collaborate in the establishment of friendly relationships within the group and the creation of a demanding but loose working spirit."},
              {title:"Adaptability / Flexibility",con:"Be capable of adapting to the work and social environment. Know how to work efficiently in different situations and with different types of people. It entails understanding and valuing different positions or viewpoints and adapting one’s approach as the situation unfolds. Includes the ability to assimilate changes, both in terms of work schemes and technology."},
              {title:"Proactivity",con:"Be capable of identifying problems, obstacles or opportunities, both current and future and respond to these. This carries along with it the capacity to take on one’s own work from a broad and non-restrictive angle, by understanding that one’s role may mean undertaking projects, activities or tasks that are different from one’s job description."}
            ],
            select2:0,
            oneStyle:{
              backgroundColor:' #0C3665',
              color:'white'
            },
            aStyle:{display:'none'},
            ops: {
              vuescroll: {
                mode: 'native',
                sizeStrategy: 'percent',
                detectResize: true
              },
              scrollPanel: {
                speed: 800,
                scrollingX: false,
              },
              rail: {
                background: '#01a99a',
                opacity: 0,
                size:'2px'
              },
              bar: {
                showDelay: 500,
                background: '#0C3665',
                size: '2px',
              }
            },
            wow:''

          }
      },
      components:{firstComponent,footComponent},
      mounted(){
          if(this.$route.query.select!=undefined){
            this.select2=this.$route.query.select
          }else{
            console.log("路由跳转参数为空")
          }
        this.wow=new WOW();
        this.wow.init()
      },
      methods:{
        gotoTop(){
          this.$refs['vs'].scrollIntoView('#d1', 500);
        },
        handleScroll(vertical, horizontal, nativeEvent) {
          let top=vertical.scrollTop
          if(top>0){
            this.isShowNav=false
          }else{
            this.isShowNav=true
          }
          window.pageYOffset=top
          this.wow.scrollHandler()
        },
          showCon(n){
            this.select2=n
          },
          show(){
            this.aStyle={display:'flex'}
          }
      }
    }
</script>

<style lang="scss" scoped>
  .header{
    transition: 1s;
    &.active{
      transform: translateY(-100%);
    }
  }
.aboutCon{
  width:100%;
  .banner{
    width:100%;
    position: relative;
    .text{
      position: absolute;
      top:60%;
      left: 11%;
      color:white;
      span{
        font-size: 35px;
        font-weight: bold;
        display: inline-block;
        padding-bottom: 10px;
        position: relative;
        border-bottom: 1px solid rgba(255,255,255,.3);
      }
    }
    .threeBtn{
      width:100%;
      color:white;
      position: absolute;
      bottom: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      span{
        display: inline-block;
        width:20%;
        color:#0C3665;
        padding:15px 10px;
        text-align: center;
        margin-left: 0.1%;
        font-weight: bold;
        cursor: pointer;
        background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
        background-size: 100% 0%;
        text-transform: uppercase;
        -webkit-transition: all .5s;
        transition: all .5s;
        background-color:rgba(255,255,255,0.9);
      }
      span:hover{
        background-size: 100% 100%;
        color:white;
      }
    }
  }
.company{
  width:100%;
  .mainOne{
    width:1280px;
    margin: 0 auto;
    padding-top: 60px;
    text-align: center;
    .leftTitle{
      width:100%;
      font-size: 25px;
      font-weight: bold;
      .b{
        color:#C7000C;
      }
      .c{
        color:#0C3665;
      }
    }
    p{
      width:80%;
      margin: 60px auto;
      line-height: 40px;
      font-family: light;
    }
    img{
      cursor: pointer;
    }
  }
  .mainTwo{
    width:100%;
    position: relative;
    margin-top: 30px;
    .blut{
      width:100%;
      height:100%;
    }
    .allText{
      position: absolute;
      width:60%;
      top:0;
      background-color: white;
      left: 20%;
      padding: 30px 2%;
      p{
        margin-left: 2%;
        line-height: 35px;
        letter-spacing: 0.5px;
        font-size: 18px;
        font-family: light;
      }
    }
  }
}
  .mission{
    width:100%;
    position: relative;
    background-color: #FBFBFB;
    .bg{
      width:90%;
      height:1514px;
      position: absolute;
      margin-left: 10%;
      z-index: -1;
    }
    .title{
      width:100%;
      text-align: center;
      padding-bottom: 60px;
      padding-top: 60px;
      p{
        font-size: 25px;
        font-weight: bold;
        color:#0C3665;
        margin-block-start: 0em;
      }
      .three{
        width:20%;
        height:1px;
        margin: 0 auto;
        position: relative;
        span{
          width:40%;
          display: inline-block;
          height:100%;
          background-color: #ECECEC;
          position: absolute;
        }
        img{
          position: absolute;
          left: 45%;
          top:-10px;
        }
      }
    }
    .leftTitle{
      width:100%;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
      .b{
        color:#C7000C;
      }
      .c{
        color:#0C3665;
      }
    }
    .item{
      width:80%;
      margin: 30px auto;
      padding-bottom: 20px;
      border-bottom: 1px solid #E1E1E1;
      p:first-child{
        font-size: 20px;
        font-weight: bold;
        color:#0C3665;
      }
      p{
        line-height: 40px;
        text-transform: capitalize;
      }

    }
  }
  .social{
    width:100%;
    background-color: #FBFBFB;
    .title{
      width:100%;
      text-align: center;
      padding-bottom: 60px;
      padding-top: 60px;
      p{
        font-size: 25px;
        font-weight: bold;
        color:#0C3665;
        margin-block-start: 0em;
      }
      .three{
        width:20%;
        height:1px;
        margin: 0 auto;
        position: relative;
        span{
          width:40%;
          display: inline-block;
          height:100%;
          background-color: #ECECEC;
          position: absolute;
          z-index: 888;
        }
        img{
          position: absolute;
          left: 50%;
          top:-10px;
          z-index: -1;
        }
      }
    }
    .item{
      width:80%;
      margin: 30px auto;
      padding-bottom: 20px;
      border-bottom: 1px solid #E1E1E1;
      p:first-child{
        font-size: 20px;
        font-weight: bold;
        color:#0C3665;
      }
      p{
        line-height: 40px;
        font-size: 14px;
        text-align: left;
        color:black;
        font-family: light;
        text-transform: capitalize;
      }
      a{
        font-family: light;
      }

    }
    .itemTwo{
      position: relative;
      a{
        width:100%;
        display:inline-block;
        text-align: left;
        height:30px;
        font-size: 15px;
        text-decoration: none;
        text-transform: capitalize;
      }
      img{
        position: absolute;
        right:0;
        top:0;
      }
    }
  }
  @media screen and (max-width: 1680px){
    .company{
      .mainTwo{
        .allText{
          height:35%;
          overflow: hidden;
          padding-bottom: 8%;
          p{
            font-size: 16px;
            line-height: 20px;
          }
          img{
            height:250px;
            width:380px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1366px){
    .company{
      .mainTwo{
        .allText{
          padding-bottom: 8%;
        }
      }
    }
  }
  @media screen and (max-width: 1280px){
    .company{
      .mainTwo{
        .allText{
          padding-bottom: 10%;
        }
      }
    }
  }
  @media screen and (max-width:768px){
    .banner{
      img{
        height:500px !important;
        object-fit: cover;
      }
    }
    .company{
      .mainOne{
        width:100%;
      }
      .mainTwo{
        .allText{
          width:80%;
          left: 10%;
          img{
            width:270px;
            height:155px;
          }
          p{
            font-size: 13px;
          }
        }
      }
    }
    .mission{
      .bg{
        height:900px;
        object-fit: contain;
      }
    }
  }
  @media screen and (max-width:450px){
    .banner{
      .threeBtn{
        flex-direction: column;
        position: static;
        padding-bottom: 30px;
        span{
          width:100%;
          font-size: 10px;
          padding: 10px 5px;
          margin-top: 10px;
          background-color:#FAFAFA;
        }
      }
      .text{
        top:50%;
      }
    }
    .company{
      .mainTwo{
        height:600px;
        .blut{
          height:600px !important;
          object-fit: cover;
          position: absolute;
          top:0;
          z-index: 0;
        }
        .allText{
          height:80%;
          display: flex;
          flex-direction: column;
          position: relative;
          z-index: 1;
          img{
            width:100%;
            height:200px;
            object-fit: cover;
          }
        }
      }
    }
    .mission{
      .leftTitle{
        width:86%;
        margin-left: 7%;
        font-size: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue